import { chartTimeFrames } from 'common/constants/chart.constants';

export function prepareOrder(order, lastTick, getInstrumentBySymbol, idx) {
  const res = {
    ...order,
    symbolPrice: lastTick,
    symbolObject: getInstrumentBySymbol(order.symbol),
    number: idx,
  };
  if (res.tp === 0) delete res.tp;
  if (res.sl === 0) delete res.sl;
  return res;
}

export const getIntervalByValue = (val) =>
  chartTimeFrames.find((interval) => interval.value === val) || {};
export const getIntervalIdxByValue = (val) =>
  chartTimeFrames.findIndex((interval) => interval.value === val) || 0;

export const getNextInterval = (val) => {
  const curIdx = getIntervalIdxByValue(val);
  let value;
  if (curIdx === chartTimeFrames.length - 1) {
    value = 0;
  } else {
    value = curIdx + 1;
  }
  return chartTimeFrames[value];
};
